// extracted by mini-css-extract-plugin
export var card = "_mf-0";
export var content = "_mf-2";
export var details = "_mf-3";
export var icon = "_mf-1";
export var iconBlue = "_mf-5";
export var iconBrand = "_mf-4";
export var iconGrayBlue = "_mf-6";
export var iconGreen = "_mf-7";
export var iconIndigo = "_mf-8";
export var iconOrange = "_mf-9";
export var iconPurple = "_mf-a";
export var iconRed = "_mf-b";
export var iconWarning = "_mf-c";